module.exports = __webpack_public_path__ + "img/logo.ffc8e59b.png";